export default __webpack_public_path__ + "static/media/Edit-documentation.c55baed7.md";